import Button from '@viking-eng/button';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

import './PageTabs.scss';

const PageTabs = ({ hideDisabled, hideIfSingleTab = true, tabs = [] }) => {
  const navigate = useNavigate();
  const activePath = (window.location.pathname || '/').toLowerCase();
  const displayTabs = tabs?.filter((tab) => !hideDisabled || tab.enabled) || [];
  return displayTabs.length > 1 && hideIfSingleTab ? (
    <div className="page-tabs row">
      <div className="col-12 text-center border-bottom">
        <ul>
          {displayTabs.map((tab) => (
            <li key={tab.title}>
              <Button
                className={tab.path === activePath ? 'active' : ''}
                disabled={!tab.enabled}
                onButtonClick={() => {
                  if (tab.path !== activePath && tab.enabled) {
                    navigate(tab.path);
                  }
                }}
              >
                {tab.title}
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;
};

PageTabs.propTypes = {
  hideDisabled: PropTypes.bool.isRequired,
  hideIfSingleTab: PropTypes.bool.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      path: PropTypes.string,
      enabled: PropTypes.bool,
    }),
  ).isRequired,
};

export default PageTabs;
